import { render, staticRenderFns } from "./pageElementGallery.vue?vue&type=template&id=005c460a&scoped=true&"
import script from "./pageElementGallery.vue?vue&type=script&lang=js&"
export * from "./pageElementGallery.vue?vue&type=script&lang=js&"
import style0 from "./pageElementGallery.vue?vue&type=style&index=0&id=005c460a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005c460a",
  null
  
)

export default component.exports